import { ElementType, IElementData } from "@pageBuilder/typings";
import { PageBackgroundRenderer } from "src/page/page-background-renderer";
import { BuyButtonWidgetRenderer } from "src/widgets/renderers/buy-button-widget/buy-button-widget-renderer";
import { CookiesButtonWidgetRenderer } from "src/widgets/renderers/cookies-button-widget/cookies-button-widget-renderer";
import { CopyrightWidgetRenderer } from "src/widgets/renderers/copyright-widget-renderer";
import { GdprRequestWidgetRenderer } from "src/widgets/renderers/gdpr/gdpr-request/gdpr-request-widget-renderer";
import { SearchResultsWidgetRenderer } from "src/widgets/renderers/search-results-widget/search-results-widget-renderer";
import { StoreSubscriptionsWidgetRenderer } from "src/widgets/renderers/store-subscriptions-widget/store-subscriptions-widget-renderer";
import { FooterSectionsAreaRenderer } from "../sections-areas/renderers/footer-sections-area-renderer";
import { HeaderSectionsAreaRenderer } from "../sections-areas/renderers/header-sections-area-renderer";
import { MainSectionsAreaRenderer } from "../sections-areas/renderers/main-sections-area-renderer";
import { FooterSectionRenderer } from "../sections/renderers/footer-section-renderer";
import { HeaderDesktopSectionRenderer } from "../sections/renderers/header/header-desktop-section-renderer";
import { HeaderMobileSectionRenderer } from "../sections/renderers/header/header-mobile-section-renderer";
import { PopUpSectionRenderer } from "../sections/renderers/pop-up/pop-up-section-renderer";
import { MeshSectionRenderer } from "../sections/renderers/section/mesh-section-renderer";
import { AccordionWidgetRenderer } from "../widgets/renderers/accordion-widget/accordion-widget-renderer";
import { BlogPostWidgetRenderer } from "../widgets/renderers/blog-post-widget/blog-post-widget-renderer";
import { BlogRollWidgetRenderer } from "../widgets/renderers/blog-roll-widget/blog-roll-widget-renderer";
import { BoxWidgetRenderer } from "../widgets/renderers/box-widget/box-widget-renderer";
import { ButtonWidgetRenderer } from "../widgets/renderers/button-widget-renderer";
import { ChatWidgetRenderer } from "../widgets/renderers/chat-widget-renderer";
import { CountdownWidgetRenderer } from "../widgets/renderers/countdown-widget-renderer";
import { DividerWidgetRenderer } from "../widgets/renderers/divider-widget-renderer";
import { EmbedWidgetRenderer } from "../widgets/renderers/embed-widget-renderer";
import { FacebookLikeWidgetRenderer } from "../widgets/renderers/facebook-like-widget-renderer";
import { BlogSubscribeWidgetRenderer } from "../widgets/renderers/form-widget/blog-subscribe-widget/blog-subscribe-widget-renderer";
import { FormWidgetRenderer } from "../widgets/renderers/form-widget/form-widget-renderer";
import { GalleryWidgetRenderer } from "../widgets/renderers/gallery-widget/gallery-widget-renderer";
import { ImageWidgetRenderer } from "../widgets/renderers/image-widget/image-widget-renderer";
import { MapWidgetRenderer } from "../widgets/renderers/map-widget-renderer";
import { MenuWidgetRenderer } from "../widgets/renderers/menu-widget/menu-widget-renderer";
import { PaypalWidgetRenderer } from "../widgets/renderers/paypal-widget-renderer";
import { SearchBarWidgetRenderer } from "../widgets/renderers/search-bar-widget/search-bar-widget-renderer";
import { SocialLinksWidgetRenderer } from "../widgets/renderers/social-links-widget-renderer";
import { SpacerWidgetRenderer } from "../widgets/renderers/spacer-widget-renderer";
import { StripeCheckoutWidgetRenderer } from "../widgets/renderers/stripe-checkout-renderer";
import { TextWidgetRenderer } from "../widgets/renderers/text-widget/text-widget-renderer";
import { TruFormWidgetRenderer } from "../widgets/renderers/truforms-widget/truforms-widget-renderer";
import { VideoWidgetRenderer } from "../widgets/renderers/video-widget/video-widget-renderer";
import { LoginWidgetRenderer } from "../widgets/renderers/website-members/login-widget/login-widget-renderer";
import { MemberMenuWidgetRenderer } from "../widgets/renderers/website-members/member-menu-widget/member-menu-widget-renderer";
import { RecoveryWidgetRenderer } from "../widgets/renderers/website-members/recovery-widget/recovery-widget-renderer";
import { RegisterWidgetRenderer } from "../widgets/renderers/website-members/register-widget/register-widget-renderer";
import { ResetPasswordWidgetRenderer } from "../widgets/renderers/website-members/reset-password-widget/reset-password-widget-renderer";
import { RendererBase } from "./renderer-base";
import { MyOrdersWidgetRenderer } from "src/widgets/renderers/my-orders-widget/my-orders-widget-renderer";
import { CheckoutWidgetRenderer } from "src/widgets/renderers/checkout-widget/checkout-widget-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";
import {
    StoreOrderDetailsWidgetRenderer
} from "../widgets/renderers/store-order-details-widget/store-order-details-widget-renderer";
import { StoreSubscriptionDetailsWidgetRenderer } from "src/widgets/renderers/store-subscription-details/store-subscription-details-renderer";
import { PricingTableWidgetRenderer } from "../widgets/renderers/pricing-plan/pricing-table-widget-renderer";
import { LogoWidgetRenderer } from "src/widgets/renderers/logo-widget/logo-widget-renderer";
import { BreadcrumbsWidgetRenderer } from "src/widgets/renderers/breadcrumbs-widget/breadcrumbs-widget-renderer";
import { LiteHeaderSectionRenderer } from "src/sections/renderers/section/simple-header-section-renderer/lite-header-section-renderer";
import {
    StoreOrderConfirmationWidgetRenderer
} from "../widgets/renderers/store-order-confirmation-widget/store-order-confirmation-widget-renderer";
import {
    CalendarEventListWidgetRenderer
} from "../widgets/renderers/calendar-event-list-widget/calendar-event-list-widget-renderer";
import { CalendarEventDetailsWidgetRenderer } from "src/widgets/renderers/calendar/calendar-event-details-widget/calendar-event-details-widget-renderer";
import { CalendarAppointmentScheduleWidgetRenderer } from "../widgets/renderers/calendar-appointment-schedule-widget-renderer";

export class RendererFactory {

    public static create(type: ElementType, renderingCommonContext: IRenderingCommonContext): RendererBase<IElementData> {
        switch (type) {
            case "PageBackground":
                return new PageBackgroundRenderer(renderingCommonContext);
            case "MainSectionsArea":
                return new MainSectionsAreaRenderer(renderingCommonContext);
            case "HeaderSectionsArea":
                return new HeaderSectionsAreaRenderer(renderingCommonContext);
            case "FooterSectionsArea":
                return new FooterSectionsAreaRenderer(renderingCommonContext);
            case "MeshSection":
                return new MeshSectionRenderer(renderingCommonContext);
            case "FooterSection":
                return new FooterSectionRenderer(renderingCommonContext);
            case "PopUpSection":
                return new PopUpSectionRenderer(renderingCommonContext);
            case "HeaderDesktopSection":
                return new HeaderDesktopSectionRenderer(renderingCommonContext);
            case "HeaderMobileSection":
                return new HeaderMobileSectionRenderer(renderingCommonContext);
            case "LiteHeaderSection":
                return new LiteHeaderSectionRenderer(renderingCommonContext);
            case "ImageWidget":
                return new ImageWidgetRenderer(renderingCommonContext);
            case "TextWidget":
                return new TextWidgetRenderer(renderingCommonContext);
            case "VideoWidget":
                return new VideoWidgetRenderer(renderingCommonContext);
            case "SpacerWidget":
                return new SpacerWidgetRenderer(renderingCommonContext);
            case "DividerWidget":
                return new DividerWidgetRenderer(renderingCommonContext);
            case "ButtonWidget":
                return new ButtonWidgetRenderer(renderingCommonContext);
            case "CountdownWidget":
                return new CountdownWidgetRenderer(renderingCommonContext);
            case "FormWidget":
                return new FormWidgetRenderer(renderingCommonContext);
            case "PaypalWidget":
                return new PaypalWidgetRenderer(renderingCommonContext);
            case "FacebookLikeWidget":
                return new FacebookLikeWidgetRenderer(renderingCommonContext);
            case "StripeCheckoutWidget":
                return new StripeCheckoutWidgetRenderer(renderingCommonContext);
            case "EmbedWidget":
                return new EmbedWidgetRenderer(renderingCommonContext);
            case "ChatWidget":
                return new ChatWidgetRenderer(renderingCommonContext);
            case "MenuWidget":
                return new MenuWidgetRenderer(renderingCommonContext);
            case "BreadcrumbsWidget":
                return new BreadcrumbsWidgetRenderer(renderingCommonContext);
            case "SubscribeWidget":
                return new BlogSubscribeWidgetRenderer(renderingCommonContext);
            case "BlogRollWidget":
                return new BlogRollWidgetRenderer(renderingCommonContext);
            case "BlogPostWidget":
                return new BlogPostWidgetRenderer(renderingCommonContext);
            case "SocialLinksWidget":
                return new SocialLinksWidgetRenderer(renderingCommonContext);
            case "BoxWidget":
                return new BoxWidgetRenderer(renderingCommonContext);
            case "MapWidget":
                return new MapWidgetRenderer(renderingCommonContext);
            case "AccordionWidget":
                return new AccordionWidgetRenderer(renderingCommonContext);
            case "RegisterWidget":
                return new RegisterWidgetRenderer(renderingCommonContext);
            case "LoginWidget":
                return new LoginWidgetRenderer(renderingCommonContext);
            case "RecoveryWidget":
                return new RecoveryWidgetRenderer(renderingCommonContext);
            case "GalleryWidget":
                return new GalleryWidgetRenderer(renderingCommonContext);
            case "MemberMenuWidget":
                return new MemberMenuWidgetRenderer(renderingCommonContext);
            case "ResetPasswordWidget":
                return new ResetPasswordWidgetRenderer(renderingCommonContext);
            case "TruFormWidget":
                return new TruFormWidgetRenderer(renderingCommonContext);
            case "GdprRequestWidget":
                return new GdprRequestWidgetRenderer(renderingCommonContext);
            case "CookiesButtonWidget":
                return new CookiesButtonWidgetRenderer(renderingCommonContext);
            case "SearchBarWidget":
                return new SearchBarWidgetRenderer(renderingCommonContext);
            case "SearchResultsWidget":
                return new SearchResultsWidgetRenderer(renderingCommonContext);
            case "CopyrightWidget":
                return new CopyrightWidgetRenderer(renderingCommonContext);
            case "BuyButtonWidget":
                return new BuyButtonWidgetRenderer(renderingCommonContext);
            case "StoreSubscriptionsWidget":
                return new StoreSubscriptionsWidgetRenderer(renderingCommonContext);
            case "StoreSubscriptionDetailsWidget":
                return new StoreSubscriptionDetailsWidgetRenderer(renderingCommonContext);
            case "StoreOrderConfirmationWidget":
                return new StoreOrderConfirmationWidgetRenderer(renderingCommonContext);
            case "MyOrdersWidget":
                return new MyOrdersWidgetRenderer(renderingCommonContext);
            case "CheckoutWidget":
                return new CheckoutWidgetRenderer(renderingCommonContext);
            case "StoreOrderDetailsWidget":
                return new StoreOrderDetailsWidgetRenderer(renderingCommonContext);
            case "PricingTableWidget":
                return new PricingTableWidgetRenderer(renderingCommonContext);
            case "LogoWidget":
                return new LogoWidgetRenderer(renderingCommonContext);
            case "CalendarEventListWidget":
                return new CalendarEventListWidgetRenderer(renderingCommonContext);
            case "CalendarEventDetailsWidget":
                return new CalendarEventDetailsWidgetRenderer(renderingCommonContext);
            case "CalendarAppointmentScheduleWidget":
                return new CalendarAppointmentScheduleWidgetRenderer(renderingCommonContext);
            default:
                throw new Error(`Element type ${type} is not supported`);
        }
    }

}
